import features from './features';
import { find } from 'lodash';

/**
 * Use value of web content field, otherwise
 * fallback to performance description.
 */

export default function displayTitle(description, webContent) {
  let customTitle = features.getOption('details', 'displayTitleWebContentId');
  if (customTitle) {
    let webContentField = find(
      webContent,
      field => parseInt(field.content_type, 10) === customTitle
    );
    return webContentField ? webContentField.content_value : description;
  } else {
    return description;
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/displayTitle.js